import { Button, Modal } from "react-bootstrap";
import useOriginApp from "../../services/useOriginApp";
import { getNewAccessToken } from "../../services/api";
import { SitelHelpDeskLanguage } from "../../sitel/demon/ui/atoms/contactPhones/sitelHelpDesk";
import authCentral from "../../services/authCentral";
import log from "../../sitel/commons/services/log";

/**
 * A modal component for displaying profile-related messages.
 *
 * @param {object} props - The component props.
 * @param {object} props.showProfileModal - The state of the profile modal.
 * @param {function} props.setShowProfileModal - The function to update the profile modal state.
 * @param {boolean} props.isNewAccount - Indicates whether it's a new account.
 * @returns {JSX.Element} The ProfileModal component.
 */
const ProfileFormModal = ({ showProfileModal, setShowProfileModal}) => {
    const originApp = useOriginApp();
    const isNewAccount = showProfileModal.isNewAccount

    const actionMessage = isNewAccount ? "Your account has been successfully created." : "Your profile has been successfully updated.";
    const errorMessage = `Error ${isNewAccount ? "CREATING new account" : "UPDATING your account"}`;

    const modalMessage = showProfileModal.success
    ? (
        <>
          <p className="display-6">Congratulations 🎉</p>
          <i className="fa-regular fa-circle-check fa-6x m-4 text-success"></i>
          <p className="fw-normal mb-0">{actionMessage}</p>
          <p className="fw-normal">Press continue to go to <strong>{originApp.url.substring(1)}</strong></p>
        </>
      )
    : (
        <>
          <p>{errorMessage}</p>
          <i className="fa-regular fa-circle-xmark fa-6x m-4 text-danger"></i>
          <p className="fw-normal">An error occurred while processing your request.</p>
          {showProfileModal.errors && showProfileModal.errors.length === 0 ? 
            (<SitelHelpDeskLanguage/>) :
            (<ul><FormatCosmoErrors errors={showProfileModal.errors} /></ul>)
          }
          
        </>
      );

    // Determine the button text based on success
    const buttonText = showProfileModal.success ? "Continue" : "Logout";

    const handleModalButtonClick = () => {
      setShowProfileModal({ ...showProfileModal, showModal: false })
      if(showProfileModal.success) {
        getNewAccessToken(
          (response) => {
            /* TODO this neeeds to be in Auth and not use env here*/
            localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_NAME, response.data.payload.access_token)
            window.location.href = originApp.url;
          },
          (response) => {
            log.debug("Error occured with fetching new access token",response);
            setShowProfileModal({ ...showProfileModal, showModal: true})
          }
      );
      } else {
        authCentral.localLogout();
        setShowProfileModal({ ...showProfileModal, showModal: false})
      }
    }

    return (
      <Modal show={showProfileModal.showModal} backdrop="static">
        {!showProfileModal.success && (
          <Modal.Header><Button
              variant="link"
              className="text-decoration-none m-0 rounded-0"
              onClick={()=>setShowProfileModal({showModal: false})}
            ><strong>Dismiss and try again</strong>
          </Button></Modal.Header>)}
        <Modal.Body className="p-4 text-center">
          <h5 className="fw-bold">{modalMessage}</h5>
        </Modal.Body>
        <Modal.Footer className="flex-nowrap p-0 justify-content-center">
          <Button
            variant="link"
            className="fs-6 text-decoration-none col-6 py-3 m-0 rounded-0 w-100"
            onClick={handleModalButtonClick}
          >
            <strong>{buttonText}</strong>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  
  export default ProfileFormModal;
  


  /**
   * Cosmo erros comes from the server after validation the form
   * it comes in the format of 
   * [
   *    field => [array of errors],
   *    field => [array of errors]
   * ]
   * @param {*} param0 
   * @returns 
   */
  function FormatCosmoErrors({errors}){
    const errorStrings = [];
    
    for(const cosmoError in errors){
      if(errors[cosmoError].length > 0){
        for(let i=0;i<errors[cosmoError].length;i++){
          errorStrings.push(errors[cosmoError][i]);
        }
      }
    }
    return <>{errorStrings.map(errstr=><li key={errstr}>{errstr}</li>)}</>;
  }
